import { SimpleGuard } from 'interfaces/guards'
import { TimeframeTyped } from 'interfaces/global'
import { getCreditAccountsActionCreator, getCreditTotalsActionCreator } from 'actions/creditActions'
import { areCreditTotalsLoadedSelector, areCreditAccountsLoadedSelector } from 'selectors/creditSelectors'

export const creditAccountsGuard: SimpleGuard<TimeframeTyped> = {
  name: 'Credit Accounts',
  checker: areCreditAccountsLoadedSelector,
  loader: (dispatch, { timeframe }) => dispatch(getCreditAccountsActionCreator(timeframe)),
}

export const creditTotalsGuard: SimpleGuard<TimeframeTyped> = {
  name: 'Credit Totals',
  checker: areCreditTotalsLoadedSelector,
  loader: (dispatch, { timeframe }) => dispatch(getCreditTotalsActionCreator(timeframe)),
}
